<template>
  <div id="app">
    <div class="page">
      <div class="page-head">
        <div class="page-head-left" v-show="imgFlag">
          <img src="./img/logo-jsq.png" />
        </div>
        <div class="page-head-left" v-show="!imgFlag">
          <img src="./img/logo.png" />
        </div>

        <div class="page-head-right">
          <span></span>
        </div>
      </div>
      <div class="page-login-1"></div>
      <div class="page-login-2"></div>

      <div class="page-foot"></div>
      <foot></foot>


     
    </div>
  </div>
</template>
<script>
import headBack from "../common/head-back";
import foot from "./channelFoot";

//接口地址
import api from "../../api/index";
//toast组件
import tips from "@/estoast";
import util from "@/utils/util";
import store from "@/store";
import * as types from "../../store/types";
import { mapGetters } from "vuex";

export default {
  name: "app",
  metaInfo: {
    title: "好运吧"
  },
  data() {
    return {
      msg: "渠道推广",
      btnText: "发送验证码",
      from: {
        mobile: "",
        code: "",
        shareType: 1,
        shareId: null
      },
      unimgSrc: require("./img/login-disagree.png"),
      imgSrc: require("./img/loggin-agree.png"),
      closeSrc: require("../../assets/img/close@2x.png"),
      imgFlag: true,
      codeshow: true,
      btnDisabled: false,
      btnDisabled: false,
      tuicode: "",
      codeimg: "",

      cid: ""
    };
  },
  mounted() {
    this.$point.init(new Date());
    store.dispatch("hideLoading");

    var channelId = this.$route.params.channelId;
    var type = this.$route.params.type;
        console.log("type:" + type);

    if (type == 1) {
      this.imgFlag = false;
    }

    console.log("sharchannelIdeid:" + channelId);
    // this.type =type;
    // this.shareid =shareid;
    // if(!util.isNum(this.channelId)){
    //     tips.toast("地址不合法")
    //     this.$router.push("/index");
    // }
    store.commit(types.SET_CHANNEL, channelId);
    this.cid = channelId;
    setTimeout(() => {
          // console.log('修改显示')
          //$('#vipOpenButton').css('display','block');
    }, 1000);
  },
  methods: {
    toPay() {
      // this.$point.eventtag(this.userid, "btn_100008");
      this.$point.eventId("btn_100008");

      var ua = window.navigator.userAgent.toLowerCase();

      if (/(Android)/i.test(navigator.userAgent)) {
        this.$point.eventuid(
          "down_app_a_" + this.cid,
          this.userid,
          "down_app"
        );
        //下载
        window.location.href = "http://wap.haoyunba.com/apk/clac/" + this.cid+"_sign.apk";

      } else {
          this.$point.eventtag(
          "down_app_o_" + this.cid,
          "down_app"
        );
        //window.location = "https://apps.apple.com/cn/app/id1502944777";
          
          
        //使用企业签签名作为下载的标识
        setTimeout(() => {
          this.$router.push("/iosSetting");
        }, 2000);

        window.location.href =
          "itms-services://?action=download-manifest&url=https://www.haoyunba.com/h5/ios/clac/manifest.plist";

          
          
      }
        
    }
  },
  watch: {},
  components: {
    headBack,foot
  }
};
</script>
<style  scoped>
.page {
  width: 750px;
  height: 1737px;
  background: rgba(55, 148, 212, 1);
}
.page-login-1 {
  background: url("./img/back-1-1.png");
  background-size: 100% 100%;
  width: 750px;
  height: 631px;
}
.page-login-2 {
  background: url("./img/back-1-2.png");
  background-size: 100% 100%;
  width: 750px;
  height: 418px;
}

.page-foot {
  background: url("./img/back-2@2x.png");
  background-size: 100% 100%;
  width: 750px;
  height: 1301px;
}

.page-head {
  width: 170px;
  height: 53px;
  margin: 14px 0 0 12px;
  position: absolute;
}
.page-head-left {
  height: 100px;
  float: left;
}
.page-head-right {
  height: 100px;
  float: left;
  margin-left: 10px;
}
.page-head .page-head-left img {
  width: 53px;
  height: 53px;
  border-radius: 4px;
}
.page-head .page-head-right span {
  height: 17px;
  font-size: 18px;
  font-family: PingFangSC;
  font-weight: 400;
  color: rgba(246, 202, 155, 1);
  line-height: 53px;
}

</style>


// WEBPACK FOOTER //
// src/components/channel/chaneldown.vue